module.exports = __webpack_public_path__ + "static/img/0545_9.46a8f42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0545_9.jpg
// module id = GR7T
// module chunks = 1